import React from 'react';
import { Section } from '../ui/Section';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <Section background="surface" data-id="element-1">
      <div className="max-w-2xl mx-auto text-center border border-brand-amber/20 rounded-2xl p-8 md:p-12 bg-brand-amber/5" data-id="element-2">
        <ShieldCheck className="h-14 w-14 text-brand-amber mx-auto mb-6" data-id="element-3" />
        <h2 className="text-2xl font-serif font-bold text-brand-cream mb-4" data-id="element-4">
          30-Day Full Reset Guarantee
        </h2>
        <p className="text-brand-parchment leading-relaxed mb-4" data-id="element-5">
          If you follow the 3-2-1 Thermal Protocol for 7 days and don't notice a
          measurable improvement in your sleep quality, email us for a full
          refund. No questions, no hoops.
        </p>
        <p className="text-brand-amber font-medium italic font-serif" data-id="element-6">
          "We're confident because the biology doesn't lie."
        </p>
      </div>
    </Section>;
}